import { getParam } from '../log'

export const isAeTemplate = () => {
    const pptId = getParam('id')
    return window.aeTemplate === 1 || getParam('aeTemplate') || getParam('isAe') || window.localStorage.getItem(`ae-template-${pptId}`)
}
